import React from "react";
import { Avatar, Tag, Typography } from "antd";
import EachActionComponent from "../../../experience/generic/elements/card/actions/EachActionComponent";
import Initials from "../generateinitials/Initials";
import "./profileOverview.css";

const ProfileHeader = ({
  displayName,
  preferredName,
  roleLabel,
  statusLabel,
  medicalRecordNumber,
  memberTitle,
  additionalPrimaryData,
  actionIcons,
  actionData,
  avatar,
}) => {
  const resolvedPreferredName = preferredName?.trim();
  const initials = <Initials value={displayName || ""} />;

  const hasChips = Boolean(roleLabel || statusLabel);
  const hasIdentifiers = Boolean(medicalRecordNumber || memberTitle);
  const hasActions = actionIcons?.length > 0;
  const hasStripContent =
    hasChips || hasIdentifiers || Boolean(additionalPrimaryData);

  return (
    <header className="profile-overview-header">
      <div className="profile-overview-header-surface">
        <div className="profile-overview-header-accent" aria-hidden />
        <div className="profile-overview-header-body">
          <div
            className={`profile-overview-header-identity-row${
              hasStripContent
                ? " profile-overview-header-identity-row--has-strip"
                : ""
            }`}
          >
            {avatar ? (
              <div className="profile-overview-header-avatar-cell profile-overview-header-avatar-slot">
                {avatar}
              </div>
            ) : (
              <Avatar
                size={72}
                className="profile-overview-header-avatar profile-overview-header-avatar-cell"
              >
                {initials}
              </Avatar>
            )}
            <div className="profile-overview-header-topbar">
              <div className="profile-overview-header-names">
                <Typography.Title
                  level={3}
                  className="profile-overview-header-name"
                >
                  {displayName}
                </Typography.Title>
                {resolvedPreferredName && (
                  <Typography.Text className="profile-overview-preferred-name">
                    Preferred Name: {resolvedPreferredName}
                  </Typography.Text>
                )}
              </div>
              {hasActions && (
                <div className="profile-overview-header-actions-group">
                  <div className="card-icon-actions profile-overview-header-actions-inner">
                    {actionIcons.map((action, index) => (
                      <EachActionComponent
                        action={action}
                        key={index}
                        actionData={actionData}
                        showIconsOnly
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
            {hasStripContent && (
              <div className="profile-overview-header-strip-outer">
                <div
                  className={`profile-overview-header-detail-strip${
                    !hasChips && !hasIdentifiers
                      ? " profile-overview-header-detail-strip--solo"
                      : ""
                  }`}
                >
                  {(hasChips || hasIdentifiers) && (
                    <div className="profile-overview-header-strip-row">
                      {hasChips && (
                        <div className="profile-overview-header-strip-chips">
                          {roleLabel && (
                            <Tag className="profile-overview-header-strip-tag profile-overview-header-strip-tag--accent">
                              {roleLabel}
                            </Tag>
                          )}
                          {statusLabel && (
                            <Tag className="profile-overview-header-strip-tag">
                              {statusLabel}
                            </Tag>
                          )}
                        </div>
                      )}
                      {hasIdentifiers && (
                        <div className="profile-overview-header-strip-ids">
                          {medicalRecordNumber && (
                            <span className="profile-overview-header-strip-id">
                              MRN {medicalRecordNumber}
                            </span>
                          )}
                          {memberTitle && (
                            <span className="profile-overview-header-strip-id">
                              {medicalRecordNumber ? (
                                <span
                                  className="profile-overview-header-strip-sep"
                                  aria-hidden
                                >
                                  ·
                                </span>
                              ) : null}
                              {memberTitle}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  )}
                  {additionalPrimaryData && (
                    <div className="profile-overview-header-strip-row profile-overview-header-strip-row--secondary">
                      {additionalPrimaryData}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default ProfileHeader;
